'use client';

import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '../state/store';
import { ChakraProvider } from '@chakra-ui/react';
import { ColorModeProvider } from './colorModeProvider';
import system from './theme';

export function GlobalProvider({ children }: { children: React.ReactNode }) {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ChakraProvider value={system}>
          <ColorModeProvider>{children}</ColorModeProvider>
        </ChakraProvider>
      </PersistGate>
    </ReduxProvider>
  );
}
